import { Row, Col } from "antd";
import Field from "ui/components/Input/Field";
import InputMoney from "ui/components/Input/InputMoney";
import AddRemoveLineButton from "ui/components/Button/AddRemoveLineButton";
import { Control, UseFormSetValue } from "react-hook-form";
import {
  LimitesReservaPeriodo,
  TipoIntervaloPeriodo,
  AreaComumRegrasReserva,
} from "core/features/area-comum/typings/index";
import SelectIntervaloPeriodo from "ui/components/Input/SelectIntervaloPeriodo";

interface LimitesReservaPeriodoItemProps {
  control: Control<AreaComumRegrasReserva, any>;
  setValue: UseFormSetValue<AreaComumRegrasReserva>;
  limites: LimitesReservaPeriodo[];
  index: number;
  showLabel?: boolean;
}

function LimitesReservaPeriodoItem({
  control,
  index,
  limites,
  setValue,
  showLabel = true,
}: LimitesReservaPeriodoItemProps) {
  const onRemove = (index: number) => {
    const copy = [...limites];

    copy.splice(index, 1);

    setValue("limitesReservaPeriodo", copy);
  };

  const limitesCopy = [...limites];

  limitesCopy.splice(index, 1);

  return (
    <Row gutter={16}>
      <Col sm={10}>
        <Field
          control={control}
          label={showLabel ? "Formato de tempo" : undefined}
          name={`limitesReservaPeriodo.${index}.tipoIntervaloPeriodoLimite`}
          rules={{ required: "Campo obrigatório" }}
          render={({ field, isInvalid }) => (
            <SelectIntervaloPeriodo
              value={field.value}
              defaultValue={null}
              onChange={(value) => {
                field.onChange(value);
              }}
              isInvalid={isInvalid}
              getPopupContainer={() => document.body}
              filterValues={[
                TipoIntervaloPeriodo.Minuto,
                TipoIntervaloPeriodo.Hora,
                ...limitesCopy.map((item) => item.tipoIntervaloPeriodoLimite),
              ]}
            />
          )}
        />
      </Col>

      <Col sm={10}>
        <Field
          label={
            showLabel
              ? "Quantas reservas podem ser feitas nesse período?"
              : undefined
          }
          name={`limitesReservaPeriodo.${index}.limite`}
          control={control}
          rules={{ required: true }}
          shouldUnregister
          render={({ field, isInvalid }) => (
            <InputMoney
              isInvalid={isInvalid}
              {...field}
              placeholder="0"
              decimalScale={0}
              decimalsLimit={0}
            />
          )}
        />
      </Col>
      <Col sm={2}>
        <AddRemoveLineButton
          showAdd={false}
          onRemove={() => onRemove(index)}
          containerProps={{
            pt: showLabel ? 4 : 0,
          }}
        />
      </Col>
    </Row>
  );
}

export default LimitesReservaPeriodoItem;
